import { createContext } from 'react';
import type { TelegramAdapter } from './telegramAdapter.js';
import type { TelegramEnvironmentState } from './telegramTypes.js';

export interface TelegramContextValue {
  readonly adapter: TelegramAdapter;
  readonly environment: TelegramEnvironmentState;
}

export const TelegramContext = createContext<TelegramContextValue | null>(null);
